/**
 * Черновик ценовой зоны в карточке проверки расценок или расчёта по тендеру.
 *
 * Черновик принадлежит одной карточке: при переходе на другую карточку
 * несохранённый выбор не переносится, а запоздалый ответ сохранения прежней
 * карточки не показывается на новой. Без этого выбор, сделанный в карточке A,
 * оставался в поле карточки B, и «Сохранить» записывал его в B.
 */
export interface ZoneDraft {
  /** id проверки или расчёта, где выбрали зону. */
  owner: string;
  value: string;
}

/** Значение поля карточки `owner`: её черновик или сохранённая зона. */
export function zoneFieldValue(
  owner: string,
  saved: string | null | undefined,
  draft: ZoneDraft | null,
): string {
  return draft !== null && draft.owner === owner ? draft.value : (saved ?? '');
}

/** Есть ли у карточки свой несохранённый выбор — можно ли сохранять. */
export function zoneDraftChanged(
  owner: string,
  saved: string | null | undefined,
  draft: ZoneDraft | null,
): boolean {
  return zoneFieldValue(owner, saved, draft) !== (saved ?? '');
}

/** Ответ сохранения карточки `requestOwner` показывается, только если она открыта. */
export function isAnswerForCard(openOwner: string, requestOwner: string): boolean {
  return openOwner === requestOwner;
}
